export const FlowField = Object.freeze({
  ROOT_NODE_ID: "rootNodeId",
  NODES: "nodes",
  NODE_OPTIONS: "nodeOptions",
});

// Field/value names mirror the v2.1 entity doc (DiagnosticFlowNodes).
export const NodeField = Object.freeze({
  ID: "id",
  TYPE: "type", // node role: START | STEP | END
  QUESTION_TYPE: "questionType", // YES_NO | TEXT | DURATION | LIST
  LABEL: "label",
  PROMPT: "prompt",
  INFORMATION: "information",
  SECTION: "section",
  REQUIRED_ROLE_ID: "requiredOutletUserRoleId",
  IS_EDGE_NODE: "isEdgeNode",
  IS_MANDATORY: "isMandatory",
  HAS_NOT_APPLICABLE: "hasNotApplicable",
  HAS_COMMENT: "hasComment",
  HAS_MEDIA_UPFRONT: "hasMediaUpfront",
  HAS_TIMER: "hasTimer",
  IS_EXPORTABLE: "isExportable",
  IS_ACTIVE: "isActive",
  LIST_OPTIONS: "listOptions",
  POSITION_X: "positionX",
  POSITION_Y: "positionY",
});

export const OptionField = Object.freeze({
  ID: "id",
  NODE_ID: "diagnosticFlowNodeId",
  LABEL: "label",
  NEXT_NODE_ID: "nextNodeId",
});

export const FlowSettingsField = Object.freeze({
  INFORMATION: "information",
  LABOR_CODES: "laborCodes",
  OUTLET_IDS: "outletIds",
  BRAND_IDS: "brandIds",
  IS_DEFAULT_FOR_WARRANTY: "isDefaultForWarranty",
  IS_ACTIVE: "isActive",
  FLOWCHART_IMAGE: "flowchartImage",
});

export const NodeType = Object.freeze({
  START: "START",
  STEP: "STEP",
  END: "END",
});

export const Handle = Object.freeze({
  YES: "yes",
  NO: "no",
  CONTINUE: "continue",
  LIST_PREFIX: "list_",
});

export const listHandleId = (index) => `${Handle.LIST_PREFIX}${index}`;

export const isListHandle = (handle) =>
  typeof handle === "string" && handle.startsWith(Handle.LIST_PREFIX);

export const listHandleIndex = (handle) =>
  isListHandle(handle) ? parseInt(handle.slice(Handle.LIST_PREFIX.length), 10) : -1;

export const EdgeStroke = Object.freeze({
  YES: "#43a047",
  NO: "#e53935",
  LIST: "#00897b",
  DEFAULT: "#78909c",
});

export function edgeStrokeForHandle(sourceHandle) {
  if (sourceHandle === Handle.YES) return EdgeStroke.YES;
  if (sourceHandle === Handle.NO) return EdgeStroke.NO;
  if (isListHandle(sourceHandle)) return EdgeStroke.LIST;
  return EdgeStroke.DEFAULT;
}

// Editable node-data fields. The (de)serializers and NodeConfigPanel iterate this,
// so a new node setting only needs adding here.
export const NODE_FIELD_SPEC = Object.freeze([
  { key: NodeField.QUESTION_TYPE, default: null },
  { key: NodeField.LABEL, default: "" },
  { key: NodeField.PROMPT, default: "" },
  { key: NodeField.INFORMATION, default: "" },
  { key: NodeField.SECTION, default: null },
  { key: NodeField.REQUIRED_ROLE_ID, default: null },
  { key: NodeField.IS_MANDATORY, default: false },
  { key: NodeField.HAS_NOT_APPLICABLE, default: false },
  { key: NodeField.HAS_COMMENT, default: false },
  { key: NodeField.HAS_MEDIA_UPFRONT, default: false },
  { key: NodeField.HAS_TIMER, default: false },
  { key: NodeField.IS_EXPORTABLE, default: false },
  { key: NodeField.IS_ACTIVE, default: true },
]);
